import { atom } from "recoil";
import { VideoType } from "../types";

const detailVideoAtom = atom<VideoType | null>({
  key: "detailVideoAtom",
  default: null,
});

export default detailVideoAtom;
